module.exports = "<hr />\n<h2>Current exchange rates</h2>\n<hr />\n\n<div *ngIf=\"rates | async; let rate\">\n<table class=\"list\">\n  <tr>\n    <td>1 HEK = {{rate.HEK | number:'0.5'}} USD</td>\n  </tr>\n  <tr>\n    <td>1 TBR = {{rate.TBR | number:'0.5'}} USD</td>\n  </tr>\n  <tr>\n    <td>1 RND = {{rate.RND | number:'0.5'}} USD</td>\n  </tr>\n</table>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/rates/rates.component.html
// module id = ./src/app/rates/rates.component.html
// module chunks = main